<template>
    <div
        class="pdf-toolbar__content"
        :class="{ 'is-open': visibleMore, 'is-h5-mode': !isNotH5Mode }"
        :style="{ overflow: overflowStyle }"
    >
        <template v-if="visibleMore">
            <span
                class="pdf-toolbar-content__left"
                v-if="isNotH5Mode"
            >
                <!-- 文档规格 -->
                <span class="toolbar__button document-info">
                    {{pageSepc(pageNumber)}}
                </span>
            </span>

            <span class="pdf-toolbar-content__right">
                <template v-if="isNotH5Mode">
                    <!-- 上一页 -->
                    <span
                        class="toolbar__button"
                        :class="{'disabled': pageNumber === 1}"
                        @click="handleJumpPage('DELETE')"
                        title="上一页"
                    >
                        <i class="iconfont iconleft rotate"></i>
                    </span>
                    <!-- 页码 -->
                    <span class="toolbar__button pagination-content">
                        <input
                            type="text"
                            :style="inputWidth"
                            v-model.number="pageNumber"
                            @change="handleJumpPage('APPOINT', true)"
                        > <span class="small-font"> / {{pageCount}}</span>
                    </span>
                    <!-- 下一页 -->
                    <span
                        class="toolbar__button"
                        title="下一页"
                        :class="{'disabled': pageNumber === pageCount}"
                        @click="handleJumpPage('ADD')"
                    >
                        <i class="iconfont iconrignt rotate"></i>
                    </span>

                    <div class="divider"></div>


                    <!-- 适应屏幕宽度 -->
                    <span
                        class="toolbar__button"
                        title="适应屏幕宽度"
                        :class="{ 'is-active': autoMode === 'WIDTH' }"
                        @click="handleAutoScale('WIDTH')"
                    >
                        <i class="iconfont iconinfeed-develop-o-"></i>
                    </span>
                    <!-- 适应高度 -->
                    <span
                        class="toolbar__button"
                        title="适应屏幕高度"
                        :class="{ 'is-active': autoMode === 'HEIGHT' }"
                        @click="handleAutoScale('HEIGHT')"
                    >
                        <i class="iconfont iconvertical-develop-o-"></i>
                    </span>

                    <!-- 抓手工具 -->
                    <span
                        class="toolbar__button"
                        title="手型工具"
                        :class="{ 'is-active': isGrab }"
                        @click="handleGrab"
                    >
                        <i class="iconfont iconhand-"></i>
                    </span>

                    <div class="divider"></div>

                </template>
                <!-- 缩小 -->
                <span
                    class="toolbar__button"
                    title="缩放"
                    @click="handleScale('DELETE')"
                >
                    <i class="iconfont iconminus"></i>
                </span>
                <!-- 缩放比例 -->
                <span class="toolbar__button">
                    <span
                        class="scale-content"
                        @click="visibleScaleOption = !visibleScaleOption"
                    >
                        {{scale | displayScale}}
                        <ul
                            class="scale-option"
                            :style="{ height: visibleScaleOption ? '288px':0 }"
                            @click.stop
                        >
                            <li @click="handleScale('FIXATION', 0.25)">25%</li>
                            <li @click="handleScale('FIXATION', 0.5)">50%</li>
                            <li @click="handleScale('FIXATION', 0.75)">75%</li>
                            <li @click="handleScale('FIXATION', 1)">100%</li>
                            <li @click="handleScale('FIXATION', 1.25)">125%</li>
                            <li @click="handleScale('FIXATION', 2)">200%</li>
                            <li @click="handleScale('FIXATION', 3)">300%</li>
                            <li @click="handleScale('FIXATION', 4)">400%</li>
                        </ul>
                    </span>
                </span>
                <!-- 放大 -->
                <span
                    class="toolbar__button"
                    title="缩放"
                    @click="handleScale('ADD')"
                >
                    <i class="iconfont iconplus"></i>
                </span>
            </span>

        </template>
    </div>
</template>

<script>
import ISO_PAGE_SPEC from '../utils/ISO_PAGE_SPEC';

const A4_DEFAULT_WIDTH = 793;
const A4_DEFAULT_HEIGHT = 1123;
const CSS_DPI = 0.75;

export default {
    data () {
        return {
            pageNumber: 1,
            timeout: null,
            visibleScaleOption: false,
            overflowStyle: 'visible',
            autoMode: '',
            visibleMore: true
        };
    },
    props: {
        currentPage: Number,
        scale: Number,
        pageCount: Number,
        isGrab: Boolean, // 是否是抓取模式
        dimensions: Array,
        isNotH5Mode: Boolean
    },
    inject: ['scrollToPage'],
    watch: {
        currentPage: {
            handler (nv) {
                this.pageNumber = nv;
            },
        }
    },
    filters: {
        displayScale (scale = 0) {
            return parseInt(scale * 100) + '%';
        }
    },
    computed: {
        // 纸张规格
        pageSepc () {
            return (pageNo = 1) => {
                let { width = 0, height = 0 } = this.dimensions[pageNo - 1];
                const pageSpec = new ISO_PAGE_SPEC(width, height);
                return `${pageSpec.type} ${pageSpec.spce} ${pageSpec.directionDesc}`;
            };
        },
        // 纸张显示的实际大小
        actualPageSpec () {
            const { pixelWidth: width = A4_DEFAULT_WIDTH, pixelHeight: height = A4_DEFAULT_HEIGHT } = this.dimensions[this.pageNumber - 1];
            return { width: width / CSS_DPI, height: height / CSS_DPI };
        },
        //输入框宽度
        inputWidth () {
            const length = this.pageNumber.toString().length;
            return {
                'width': 8 * (length + 1) + 'px'
            };
        }
    },
    methods: {
        // 节流
        throttle (func, wait) {
            return () => {
                if (!this.timeout) {
                    this.timeout = setTimeout(() => {
                        this.timeout = null;
                        func();
                    }, wait);
                }
            };
        },

        /** 是否开启手型模式 */
        handleGrab () {
            this.$emit('update:isGrab', !this.isGrab);
        },

        triggerVisible () {
            this.visibleScaleOption = false;
            this.visibleMore = !this.visibleMore;
            // 动态改变 overflow 不好的实现
            if (this.visibleMore) {
                setTimeout(() => {
                    this.overflowStyle = 'visible';
                }, 400);
            } else {
                this.overflowStyle = 'hidden';
            }
        },

        /**
         * @param auto 是否自动调节当前缩放比例
         */
        handleAutoScale (type = 'WIDTH', auto = true, isOptimum = false) {
            this.throttle(() => {
                this.autoMode = '';
                let { clientWidth = 0, clientHeight = 0 } = document.querySelector('.pdf-viewer-container__middle');

                clientWidth = clientWidth - 8;
                let scale = 1;
                if (isOptimum) {
                    const { width, height } = this.actualPageSpec;
                    const isHorizontalVersion = width > height; // 是否是横版文件
                    const getScale = (size, defaultSize, clientSize) => {
                        // 若纸张尺寸 大于 屏幕尺寸 则满屏展示
                        if (size > clientSize) {
                            return clientSize / size;
                        }

                        // 默认大尺寸 小于 纸张尺寸 则 按默认大小展示
                        if (size < defaultSize) {
                            return defaultSize / size;
                        }

                        return 1;
                    };

                    scale = isHorizontalVersion ? getScale(height, A4_DEFAULT_WIDTH, clientHeight) : getScale(width, A4_DEFAULT_WIDTH, clientWidth);
                } else if (auto) {
                    this.autoMode = type;
                    if (type === 'WIDTH') {
                        scale = clientWidth / this.actualPageSpec.width;
                    } else {
                        scale = clientHeight / this.actualPageSpec.height;
                    }
                }
                this.$emit('update:scale', Math.ceil(scale * 100) / 100);
            }, 200)();
        },

        /** 处理缩放 */
        handleScale (method, value) {
            this.throttle(() => {
                const steps = new Map([
                    ['ADD', 0.1],
                    ['DELETE', -0.1],
                    ['FIXATION', value]
                ]);
                const step = steps.get(method);
                const scale = method === 'FIXATION' ? step : this.scale + step;
                this.visibleScaleOption = false;
                this.$emit('update:scale', scale);
            }, 300)();
        },

        /** 处理页码 */
        handleJumpPage (type, isValue) {
            this.throttle(() => {
                const steps = new Map([
                    ['START', 1],
                    ['END', this.pageCount],
                    ['ADD', 1],
                    ['DELETE', -1],
                    ['APPOINT', +this.pageNumber]
                ]);
                const step = steps.get(type);
                let pageNo = this.currentPage;
                // 不能越界
                if (this.currentPage === 1 && type === 'DELETE' || this.currentPage === this.pageCount && type === 'ADD') return;
                pageNo = isValue ? step : step + pageNo;
                if (step > this.pageCount) {
                    pageNo = this.pageCount;
                }
                this.scrollToPage?.(pageNo);
            }, 300)();
        },
        onkeyup () {
            // const value = e.target.value;
            // if(value.length==1){
            //     e.target.value=value.replace(/[^1-9]/g,'');
            // }else{
            //     e.target.value=value.replace(/\D/g,'');
            // }
        }
    }
};
</script>

<style lang="less" scoped>
@pdf-toolbar__background: #f2f3f4;
@pdf-toolbar__input: #f2f3f4;
@pdf-toolbar__font: #7f8997;
@pdf-toolbar__divider: #4c596e;
@pdf-toolbar__info: #050607;
@pdf-toolbar__hover: rgba(193, 198, 205, 0.5);
@pdf-toolbar__disabled: #c1c6cd;
@pdf-toolbar__input_color: #001330;
@pdf-toolbar__border: #e4e4e4;

.iconfont {
    font-size: 16px;
    padding: 4px;
    color: @pdf-toolbar__divider;

    &.init-status {
        font-size: 16px;
        padding: 0;
        background: transparent !important;
    }
}

.pdf-toolbar__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    line-height: 24px;
    padding: 0 16px;
    font-size: 14px;
    transition: width 0.3s;
    background: @pdf-toolbar__background;
    color: @pdf-toolbar__font;
    text-align: right;
    width: 100%;
    border-top: 1px solid @pdf-toolbar__border;

    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    white-space: nowrap;

    .pdf-toolbar-content__right,
    .pdf-toolbar-content__left {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .document-info {
        color: @pdf-toolbar__font;
        font-size: 12px;
    }

    &.is-h5-mode {
        justify-content: center;
    }

    .small-font {
        font-size: 12px;
        color: @pdf-toolbar__font;
        transform: scale(0.88);
    }

    .pagination-content {
        input {
            position: relative;
            top: 1px;
            width: 26px;
            height: 23px;
            padding: 0;
            display: inline-block;
            text-align: center;
            font-size: 14px;
            background: @pdf-toolbar__input;
            color: @pdf-toolbar__input_color;
            outline: none;
            border: none;
        }
    }

    .scale-content {
        background: @pdf-toolbar__input;
        padding: 2px 6px;
        position: relative;
        display: inline-block;
        line-height: 20px;
        min-width: 30px;
        text-align: center;
        color: @pdf-toolbar__input_color;

        &:hover {
            background: @pdf-toolbar__hover;
        }

        i {
            color: @pdf-toolbar__font;
        }

        .scale-option {
            position: absolute;
            bottom: 28px;
            left: -40px;
            background: #fff;
            width: 100px;
            height: 0;
            text-align: center;
            color: @pdf-toolbar__input_color;
            padding: 0;
            transition: all 0.1s;
            overflow: hidden;
            box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.2);

            li {
                list-style: none;
                padding: 0 20px;
                line-height: 36px;

                &:hover {
                    background: #f2f2f2;
                }
            }
        }
    }

    .divider {
        display: inline-block;
        width: 1px;
        height: 12px;
        background: @pdf-toolbar__border;
        margin: 0 12px;
    }

    .rotate {
        display: block;
        transform: rotate(90deg);
    }

    .toolbar__button {
        cursor: pointer;
        user-select: none;

        &+.toolbar__button {
            margin-left: 8px;
        }

        &.is-active {
            .iconfont {
                background: @pdf-toolbar__hover;
            }
        }

        &:hover {
            .iconfont {
                background: @pdf-toolbar__hover;
            }
        }

        &.disabled {
            i {
                color: @pdf-toolbar__disabled !important;
            }

            cursor: no-drop;
        }
    }
}
</style>
